module.exports = __webpack_public_path__ + "assets/media/evening.9dde35e4.mp3";